module.exports = __webpack_public_path__ + "media/images/front/materials/vidrio-9dc1f4fd858a441d8a901d86d73242c8.jpg";